import { SET_KEY_VALUE, UPDATE_KEY_VALUE, UNSET_KEY_VALUE } from './actionTypes';

export const setKeyValue = (key, data) => ({
  type: SET_KEY_VALUE, payload: { key, data },
});

export const updateKeyValue = (key, data) => ({
  type: UPDATE_KEY_VALUE, payload: { key, data },
});

export const unsetKeyValue = (key) => ({
  type: UNSET_KEY_VALUE, payload: key,
});
